import { render, staticRenderFns } from "./OrderListView.vue?vue&type=template&id=08ddf390&"
import script from "./OrderListView.vue?vue&type=script&lang=js&"
export * from "./OrderListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports